<template>
  <div v-if="banner">
    <div
      :class="'adn-' + banner.contentText.split('_')[1]"
      class="takeover-banner"
      style="display: none;"
    />
  </div>
</template>
<script>
import { defineComponent, onMounted } from "vue";
import { useAdnuntius } from "./adnuntius";

export default defineComponent({
  name: "AppTakeoverBanner",
  props: {
    banner: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { adnuntiusFetch } = useAdnuntius();
    onMounted(() => adnuntiusFetch([props.banner], {}));
  }
});
</script>
<style scoped lang="scss">
.takeover-banner {
  position: fixed;
  z-index: 50000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  width: inherit !important;
  height: inherit !important;
}
</style>
